import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, CardHeader, CardBody, Badge } from "shards-react";
import AthleteMeetPicker from "../components/AthleteMeetPicker";
import AthleteSignUpComponent from "../components/AthleteSignUpComponent";
import SelectedTeamContext from "../components/ContextSelectedTeam.js";
import FirestoreModel from "../firestoreModel";
import OutControl from "../components/OutComponent.js"; // Import the missing component

const ParentViewProvider = function (props) {

    const [teamDetails, setTeamDetails] = useState(null);
    const [isOut, setIsOut] = useState(false);
    const [teamSignups, setTeamSignups] = useState(null);

    useEffect(() => {
        const fireModel = new FirestoreModel();
        debugger;
        let teamId = "";

        if (!(props.location === undefined || props.location === null))
            if (!(props.location.state === undefined || props.location.state === null)) {
                teamId = props.location.state.teamId;
            }

        Promise.all(
            [
                fireModel.fetchTeamAsync(teamId)
            ]
        ).then((values) => {
            // Get age events from the team or if not there from the division defaults
            // it is possible that not all age groups have overrider, therefore we must merge the missing 
            // age groups into those that are set.
            const team = values[0];

            // Check to see if all age groups have data, if so dont bother getting defaults
            const ageGroupList = [];

            team.Divisions.forEach((div) => {
                let objCheck = ageGroupList.find((e) => e === div.AgeGroupId);
                if (ageGroupList.find((e) => e === div.AgeGroupId) === undefined) {
                    ageGroupList.push(div.AgeGroupId);
                }
            }
            )

            let missingFound = false;

            if (team.AgeEvents === undefined)
                team.AgeEvents = [];

            team.Divisions.forEach((div) => {
                if (team.AgeEvents.find((e) => e.DivisionId === div.AgeGroupId) === undefined)
                    missingFound = true;
            }
            )

            console.log(missingFound)
            // If there was a missing set of age events fill it in from detault
            //if (team.AgeEvents == null || team.AgeEvents.length === 0) {
            if (missingFound) {
                Promise.all(
                    [
                        fireModel.fetchDefaultTeamEvents(team)
                    ]
                ).then((values) => {
                    team.Divisions.forEach((div) => {
                        if (team.AgeEvents.find((e) => e.DivisionId === div.AgeGroupId) === undefined) {
                            // push the data from default to the age event list - hope it is same format
                            console.log({ notFound: div })
                            values[0].forEach((defaultEvent) => {
                                if (defaultEvent.DivisionId === div.AgeGroupId) {
                                    team.AgeEvents.push(defaultEvent);
                                }
                            })

                        }
                    }
                    )

                    //setTeamEvents(values[0]);
                    setTeamDetails(team);
                })
            }
            else
                setTeamDetails(values[3]);
        })





    }, [props.location]);




    const store = {
        teamDetailsStore: [teamDetails, setTeamDetails],
        isOutStore: [isOut, setIsOut],
        teamSignupsStore: [teamSignups, setTeamSignups]
    };

    return (
        <SelectedTeamContext.Provider value={store}>
            <ParentView {...props} />
        </SelectedTeamContext.Provider>
    );
};

const ParentView = (props) => {
    const title = "Athlete Self Sign-up for Meets";

    const [teamDetails, setTeamDetails] = React.useContext(SelectedTeamContext).teamDetailsStore;
    const [isOut, setIsOut] = React.useContext(SelectedTeamContext).isOutStore;
    const [teamSignUps, setTeamSignUps] = React.useContext(SelectedTeamContext).teamSignupsStore;
    const [outList, setOutList] = useState([]);

    const [selectedMeet, setSelectedMeet] = useState(null);
    const [selectedAthlete, setSelectedAthlete] = useState(null);

    useEffect(() => {
        if (teamDetails !== null && selectedMeet !== null) {
            const fireModel = new FirestoreModel();

            Promise.all(
                [
                    fireModel.fetchMeetTeamEventSignupsAsync(teamDetails.Id, selectedMeet.MeetId),
                    fireModel.fetchMeetTeamTagsAsync(teamDetails.Id, selectedMeet.MeetId)
                ]
            ).then((values) => {
                console.log(
                    "Fetched signups:",
                    {
                        signups: values[0],
                        teamId: teamDetails.Id,
                        meetId: selectedMeet.MeetId,
                        outs: values[1].OutList,
                    }
                );
                setTeamSignUps(values[0].athleteSignUps);

                if (values[1].OutList != null) {
                    setOutList(values[1].OutList);
                    if (selectedAthlete != null && selectedAthlete.AthleteId != null) {
                        const isouttest = values[1].OutList.includes(selectedAthlete.AthleteId)

                        console.log({ test: isouttest });
                        setIsOut(isouttest);
                    }

                    else
                        setIsOut(false);

                }

                else
                    setOutList([]);
            });
        }
    }, [teamDetails, selectedMeet, selectedAthlete]);


    const handleMeetChange = (meet) => {
        setSelectedMeet(meet);
    };

    const handleAthleteChange = (athlete) => {
        setSelectedAthlete(athlete);

        setOutFromArray(outList);

    };

    const setOutFromArray = (localOutList) => {
        if (selectedAthlete != null) {

            console.log("Out Flag for Athlete: ", { athlete: selectedAthlete });
            console.log("Out List: ", localOutList);
            if (localOutList != null && localOutList.length > 0) {
                const outFlag = localOutList.find((o) => o.AthleteId === selectedAthlete.AthleteId);
                console.log("Out Flag for Athlete: ", { outFlag, athleteId: selectedAthlete.AthleteId });
                if (outFlag !== undefined) {
                    setIsOut(true);
                } else {
                    setIsOut(false);
                }
            }

        }
    }

    const handleOutChange = (outFlag) => {
        // find local entry
        console.log("Out Flag: ", outFlag, selectedAthlete.AthleteId);
        const newOutList = outList.filter((e) => e !== selectedAthlete.AthleteId);

        if (outFlag === false) {
            const id = newOutList.indexOf(selectedAthlete.AthleteId);
            if (id >= 0)
                newOutList.splice(id, 1);
        }
        else {
            newOutList.push(selectedAthlete.AthleteId);
        }

        const fireModel = new FirestoreModel();

        Promise.all(
            [
                fireModel.putOutList(teamDetails.Id, selectedMeet.MeetId, newOutList)
            ]
        ).then((values) => {
            console.log("done");
        })

        setOutList(newOutList);



        setIsOut(outFlag);
    };

    let newAthleteSignUps = null;
    if (teamSignUps != null && selectedAthlete != null && selectedAthlete.AthleteId !== undefined) {
        newAthleteSignUps = []
        newAthleteSignUps = teamSignUps.filter((p) => p.AthleteId === selectedAthlete.AthleteId);
        console.log("New Athlete Signups: ", { newAthleteSignUps, selectedAth: selectedAthlete.AthleteId });
    }

    console.log({ render: { props, selectedMeet, selectedAthlete, isOut, teamDetails, newAthleteSignUps } });

    return (
        <Container fluid className="main-content-container px-4">
            <Row noGutters className="page-header py-4">
                <Col className="text-left" lg="3">
                    <strong className="text-muted d-block my-2">{title}</strong>
                </Col>
            </Row>
            <Row>
                <Col lg="6">
                    <Card small className="mb-4 pt-3">
                        <CardBody>
                            {teamDetails && teamDetails.Id && (
                                <AthleteMeetPicker
                                    clubId={teamDetails.ClubId}
                                    teamId={teamDetails.Id}
                                    onMeetChange={handleMeetChange}
                                    onAthleteChange={handleAthleteChange}
                                />
                            )}

                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col lg="12">
                    <Card large className="mb-4 pt-3">
                        <CardBody>

                            <strong className="text-right d-block my-2">
                                {selectedMeet && selectedAthlete && (

                                    <OutControl setOutFlag={handleOutChange} initialType={isOut}></OutControl>
                                )
                                }
                            </strong>
                            {selectedMeet && selectedAthlete && isOut === false && (
                                <AthleteSignUpComponent
                                    showComments={false}
                                    athlete={selectedAthlete}
                                    meet={selectedMeet}
                                    team={teamDetails}
                                    signups={newAthleteSignUps}
                                    teamEvents={teamDetails == null ? null : teamDetails.AgeEvents}
                                    onChangesDetected={(changes) => console.log(changes)}
                                />
                            )}
                        </CardBody>
                    </Card>

                </Col>
            </Row>
        </Container>
    );
};

export default ParentViewProvider;